module.exports = __webpack_public_path__ + "img/frankliniella-intonsa.4125b63e.jpg";